export default __webpack_public_path__ + "static/media/logo-dark1.8b814112.png";